/*
 * @Description: 
 * @Author: 
 * @Date: 2022-04-20 16:23:49
 * @LastEditTime: 2022-08-24 10:46:46
 * @LastEditors: dongqianqian
 * @Usage: 
 */
const IP = process.env.npm_config_ip
const domin = process.env.npm_config_domin
let BASE_URL = `http://${IP}:9001`;
let PROJECT_URL = domin ? `${domin}:8604` : `http://${IP}:8604`
let COMPANY_URL = domin ? `${domin}:8210` : `http://${IP}:8210`
let BASE_URL_HTGL = `http://${IP}:9100`
let BASE_URL_LOGIN = domin ? `${domin}:8304` : `http://${IP}:8304`
let BASE_URL_HOME = domin ? `${domin}:8001` : `http://${IP}:8001`
let EXPORT_URL = `http://${IP}/center`
let BASE_PLATFORMLOGO_URL = domin ? `${domin}:9595` : `http://${IP}:9001`
export { BASE_URL, PROJECT_URL, COMPANY_URL, BASE_URL_HTGL, BASE_URL_LOGIN, BASE_URL_HOME, EXPORT_URL, BASE_PLATFORMLOGO_URL }
